export default ({request}) =>({
    masWarehouseListApi(data = {}){
        return request({
            url: '/master/masterWarehouse/list',
            method:'post',
            data,
        })
    },
    masWarehouseSaveApi(data = {}){
        return request({
            url: '/master/masterWarehouse/save',
            method:'post',
            data,
        })
    },
    masWarehouseDetailApi(data = {}){
        return request({
            url: '/master/masterWarehouse/detail',
            method:'post',
            data,
        })
    },
    masWarehouseDelApi(data = {}) {
        return request({
          url: '/master/masterWarehouse/del',
          method: 'post',
          data,
        })
    },
})